/* RESPONSIBLE TEAM: team-ai-agent */

import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import WorkspaceSettingsRoute from 'embercom/routes/apps/app/settings/base/workspace-settings-route';
import type RouterService from '@ember/routing/router-service';

export default class HelpdeskAiRoute extends WorkspaceSettingsRoute {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare router: RouterService;

  analytics = {
    section: 'settings',
    place: 'ai-assist',
  };

  get titleToken() {
    return this.intl.t('ai-assist.settings.title');
  }
}
